export default "__VITE_ASSET__DQVw_p8S__"